import { Controller } from "@hotwired/stimulus"

// A boost chip: the remove button only shows for whoever boosted.
export default class extends Controller {
  static targets = ["remove"]
  static values = { boosterId: Number }

  connect() {
    const own = this.boosterIdValue === Number(document.body.dataset.userId)
    this.removeTargets.forEach((el) => (el.hidden = !own))
    this.element.classList.toggle("chat-boost--own", own)
  }
}
